<template>
  <div v-if="cellData" :class="{ 'dx-datagrid-summary-item': cellData.row?.groupIndex >= 0 || cellData.data?.row?.groupIndex >= 0 }">
    <div v-if="cellData" class="d-flex flex-row">
      <div class="rescellindicator" v-if="thresholds" :style="getThresholdColorInternal()" />
      <div>
        {{ getResult() }}
      </div>
    </div>
    <div v-if="resultVal != null && !Number.isNaN(this.resultVal) && questionCount != null">
      {{ `(#Q: ${questionCount})` }}
    </div>
  </div>
</template>

<script>
import ThresholdColor from '@/mixins/ThresholdColor-APP_TARGET';

export default {

  mixins: [ ThresholdColor ],

  props: {
    cellData: { type: Object, default: () => {} },
    thresholds: null,
    percentageNumberOfDecimalPoints: { type: Number, default: null },
    placeholderNaN: { type: String, default: 'N/A'}
  },

  mounted() {
    // console.log('ResultTable - mounted');
    this.extractResult();
  },


  data() {
    return {
      data: null,
      resultVal: undefined,
      questionCount: undefined
    };
  },

  methods: {
    extractResult() {

      const cell = this.cellData?.data ? this.cellData.data : this.cellData;
      if (cell) {
        let result = cell.value;

        if (cell.rowType === 'group')
        {
          let items = cell.items ?? cell.collapsedItems;
          if (cell.row.groupIndex === 0)
          {
            // Check subitems on groupIndex = 1, if available
            items = items?.[0].items ?? items?.[0].collapsedItems ?? items;
            this.data = items?.[0].RootParent;
          }
          else
            this.data = items?.[0].Parent;

          result = _.get(this.data, cell.column.dataField);
        }
        else
          this.data = cell;

        // Needed for RankingTable because context is based on columns instead of rows there
        if (typeof result === 'object')
        {
          this.data = result;
          result = result.Result;
          if (APP_TARGET === "cupra")
            this.questionCount = this.data.AnsweredQuestionCount;
        }

        if (typeof result === 'string')
          this.resultVal = Number(result.replace(',','.'));
        else
          this.resultVal = Number(result);

        // this.cellData.value = this.resultVal;
      }
    },

    getResult() {
      //console.log('getResult', this.cellData);
      if (this.resultVal != null && this.resultVal != undefined && !Number.isNaN(this.resultVal))
        return this.percentageNumberOfDecimalPoints != null ?
          (this.resultVal == 100 ?
          this.$n(this.resultVal, { minimumFractionDigits: 0, maximumFractionDigits: 0}) :
          this.$n(this.resultVal, { minimumFractionDigits: this.percentageNumberOfDecimalPoints, maximumFractionDigits: this.percentageNumberOfDecimalPoints})) + '%' :
          this.resultVal;
      else
        return this.placeholderNaN;
    },

    getThresholdColorInternal() {
      let retVal = '';

      if (!isNaN(this.resultVal)) {
        retVal = 'background-color: ' + this.getThresholdColor(this.thresholds, this.resultVal, '#fff', this.data) + ';';
      }

      return retVal;
    }
  }
};
</script>

<style>
.rescellindicator {
  margin-top: 2px;
  margin-right: 3px;
  width: 15px;
  height: 15px;
}
</style>
